import http from '@/utils/http';
import { normalizePcConsoleTopChartsApiPayload } from '@intelligence/pages/TopCharts/_config/topchartFilterCfg';

// 获取关键字列表数据
export async function fetchKeywords(params: {
  entity_type: string;
  keyword: string;
  system_type: string;
  complement: string;
}): Promise<any> {
  return http({
    url: '/api/v1/homepage/pc/searchPullDown',
    method: 'post',
    data: params,
    rawData: true,
  });
}

// 添加对比游戏
export async function addComparingGames(params: {
  entity_type: string;
  game_list: {
    entity_type: string;
    game_id: string;
    sequence: number;
  }[];
}): Promise<unknown> {
  return http({
    url: '/api/v1/intelligence_pc/compare/addCompare',
    method: 'post',
    data: params,
    rawData: true,
  });
}

// 删除PCConsole对比中的对比游戏（不是删除游戏，目前沿用mobile对比 删除对比游戏的接口）
export async function deleteComparingGames(params: { id: string[] }): Promise<unknown> {
  return http({
    url: '/api/v1/intelligence_pc/compare/deleteCompare',
    method: 'post',
    data: params,
    rawData: true,
  });
}

// ComparePCConsoleBeta版本新接口
export const fetchComparePCConsoleMetricData = (payload: any, config: any): Promise<any> => {
  const params = { ...payload, adjust_metric: payload?.adjust_metric ?? true };
  return http({
    url: '/api/v1/intelligence_pc/compare/pcConsoleMetricData',
    method: 'post',
    data: normalizePcConsoleTopChartsApiPayload(params),
    rawData: true,
    ...config,
  }) as Promise<any>;
};

// ComparePCConsoleBeta游戏搜索快捷游戏
export const fetchShortGameListFromType = (payload: any): Promise<any> => {
  return http({
    url: '/api/v1/intelligence_pc/compare/tagGames',
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

// ComparePCConsoleBeta游戏搜索快捷游戏-Opinion
export const fetchComparePCConsoleOpinionMetricData = (payload: any): Promise<any> => {
  return http({
    url: '/api/v1/opinion_pc/intelligence/metrics/list',
    method: 'post',
    data: payload,
  }) as Promise<any>;
};
